import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    
export type GetNameProjectQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetNameProjectQuery = { __typename?: 'Query', nameProject?: string | null };


export const GetNameProjectDocument = gql`
    query getNameProject {
  nameProject @client
}
    `;

/**
 * __useGetNameProjectQuery__
 *
 * To run a query within a React component, call `useGetNameProjectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNameProjectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNameProjectQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNameProjectQuery(baseOptions?: Apollo.QueryHookOptions<GetNameProjectQuery, GetNameProjectQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNameProjectQuery, GetNameProjectQueryVariables>(GetNameProjectDocument, options);
      }
export function useGetNameProjectLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNameProjectQuery, GetNameProjectQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNameProjectQuery, GetNameProjectQueryVariables>(GetNameProjectDocument, options);
        }
export type GetNameProjectQueryHookResult = ReturnType<typeof useGetNameProjectQuery>;
export type GetNameProjectLazyQueryHookResult = ReturnType<typeof useGetNameProjectLazyQuery>;
export type GetNameProjectQueryResult = Apollo.QueryResult<GetNameProjectQuery, GetNameProjectQueryVariables>;